import { CmsImage, isNotNull, isNotUndefined } from '@bfa/nextjs-common/utils';

import { NonEmptyArray } from './types';

/**
 * Joins the given cms images into an object
 * separating the sources, alternatives texts
 * and calculating the aspect ratio for each one.
 *
 * @param cmsImages - Array of cmsImage.
 * @returns An ExtractedCmsImage type with 3 attributes:
 * src as a non empty array of string,
 * alt as a non empty array of string
 * and aspectRatio as a non empty array of [number, number].
 */

type ExtractedCmsImage = {
  src: NonEmptyArray<string>;
  alt: NonEmptyArray<string>;
  aspectRatio: NonEmptyArray<[number, number]>;
};

export const extractAttributesFromCmsImages = (
  cmsImages: (CmsImage | null | undefined)[]
) => {
  const notUndefinedCmsImages = cmsImages
    .filter(isNotNull)
    .filter(isNotUndefined);
  if (notUndefinedCmsImages.length === 0) return null;

  return {
    src: notUndefinedCmsImages.map((cmsImage) => cmsImage.src),
    alt: notUndefinedCmsImages.map((cmsImage) => cmsImage.alt),
    aspectRatio: notUndefinedCmsImages.map((cmsImage) =>
      cmsImage.width && cmsImage.height
        ? [cmsImage.width, cmsImage.height]
        : [4, 3]
    ),
  } as ExtractedCmsImage;
};
